import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, trend }) => {
  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success';
      case 'negative':
        return 'text-error';
      default:
        return 'text-text-muted';
    }
  };

  const getChangeIcon = (type) => {
    switch (type) {
      case 'positive':
        return 'TrendingUp';
      case 'negative':
        return 'TrendingDown';
      default:
        return 'Minus';
    }
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-6 hover:bg-hover transition-colors duration-150">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-accent/20 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={20} className="text-accent" />
          </div>
          <h3 className="text-sm font-medium text-text-secondary">{title}</h3>
        </div>
        {trend && (
          <div className="w-16 h-8 bg-background rounded flex items-center justify-center">
            <Icon name="BarChart3" size={14} className="text-text-muted" />
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        <div className="text-2xl font-bold text-text-primary">{value}</div>
        {change && (
          <div className={`flex items-center space-x-1 text-sm ${getChangeColor(changeType)}`}>
            <Icon name={getChangeIcon(changeType)} size={14} />
            <span>{change}</span>
            <span className="text-text-muted">vs last month</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;